import {FilterItem} from './filter-item';

export class ParentItem {
  name: string;
  selected: boolean;
  fullSupportedSystems: string[]; // hack to avoid any
  allSupportedSystems: string[]; // hack to avoid any
  subItems: { [key: string]: ParentItem } | { [key: string]: FilterItem };
  remainingItems?: number; // hack to avoid any

  constructor(name: string, subItems: { [key: string]: ParentItem } | { [key: string]: FilterItem }) {
    this.name = name;
    this.selected = false;
    this.subItems = subItems;
  }
}
